import Box from '@material-ui/core/Box';
import CommonButton from 'app/components/ReviewButton';
import { TRANSLATION_KEYS } from 'app/constants/transalations';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ViewErrorButtonProps } from '../types';
import { ErrorHandlerModal } from './ErrorHandlerModal';

export const ViewErrorButton = ({ onClick, errors }: ViewErrorButtonProps) => {
  const { t } = useTranslation([
    TRANSLATION_KEYS.REVIEW,
    TRANSLATION_KEYS.COMMON,
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const nonRetryableErrors = (errors ?? []).filter(
    e => e.code === 'NON_RETRYABLE'
  );
  const hasNonRetryable = nonRetryableErrors.length > 0;

  return (
    <Box mt={1.5} display='flex'>
      {hasNonRetryable ? (
        <>
          <CommonButton
            text={t('View errors')}
            onClick={() => setIsModalOpen(true)}
            variant='tertiary'
            toolTip
            toolTipMsg={t(
              'View non-retryable errors that caused this task to fail'
            )}
          />
          <ErrorHandlerModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            errors={nonRetryableErrors}
          />
        </>
      ) : (
        <CommonButton text={t('Retry')} onClick={onClick} variant='tertiary' />
      )}
    </Box>
  );
};
